export const SingleChoiceField = {
  default: 'GC_BLANK_DEFAULT',
  style: 3,
  minimum: 2,
  maximum: 5,
  listType: 'type-my-own',
  typeMyOwn: '',
  type: 'Single Choice'
};
export default SingleChoiceField;